import React from 'react';

import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import { EnumRejectOrderReason } from '../../../../../constants/enum';
import { isEmpty } from '../../../../../utils/utils';

function RejectOrderCustomModal({
  isOpenDialog,
  rejectCustomOrder,
  handleRejectOrder,
  handleUpdateOrder,
  handleCustomRejectOrder,
}) {
  const { customNote } = rejectCustomOrder;
  return (
    <Modal isOpen={isOpenDialog} className="out-of-stock-dish-modal">
      <ModalHeader>{trans('mod_restaurant_custom_reject_order')}</ModalHeader>
      <ModalBody>
        <div style={{ margin: 10 }}>
          <textarea
            className="form-control mt-2"
            style={{ fontSize: 16 }}
            placeholder={trans('mod_enter_other_reasons')}
            value={customNote || ''}
            onChange={event => handleCustomRejectOrder(event.target.value)}
          />
        </div>
      </ModalBody>
      <ModalAction>
        {!isEmpty(customNote) && (
          <ModalButton onClick={handleUpdateOrder}>
            {trans('common_yes')}
          </ModalButton>
        )}
        <ModalButton
          type="cancel"
          onClick={() =>
            handleRejectOrder(EnumRejectOrderReason.CHOOSE_OPTION.id)
          }
        >
          {trans('mod_go_back')}
        </ModalButton>
      </ModalAction>
    </Modal>
  );
}

export default RejectOrderCustomModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/RejectOrderCustomModal.jsx